import auth0 from "auth0-js";
import jwtDecode from "jwt-decode";
import history from "../history";
import config from "../config";
import ToastOptions from "../common/toast/toastr-config.js";
import toastr from "toastr";

export default class Authentication {
  constructor() {
    this.fiveMinutes = 1000 * 60 * 5;
    this.auth0 = new auth0.WebAuth(config.auth0Config);
  }

  login = () => {
    this.auth0.authorize();
  };

  handleAuthentication = () => {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        history.replace("/accounts");
      } else if (err) {
        history.replace("/");
        toastr.options = ToastOptions;
        toastr.error(`Error: ${err.error}. Check the console for further details.`);
      }
    });
  };

  setSession = authResult => {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify(
        authResult.expiresIn * 1000 + new Date().getTime()
    );

    console.log("Expires at: " + new Date(expiresAt))
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);


  };

  logout = () => {
    // Clear Access Token and ID Token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    // navigate to the index route
    history.replace("/");
  };

  /**
   * Put this as a separate function because for some reason when inline, there was no access to this
   * @param err
   * @param authResult
   */
  authenticationSession = (err, authResult) => {
    if (err) {
      console.log("ERR:" + JSON.stringify(err))
    } else {
      console.log("Renewing Session")
      this.setSession(authResult);
    }
  }


  isAuthenticated = () => {
    // Check whether the current time is past the
    // Access Token's expiry time
    //Getting the access token allows us to determine if the user logged out.  If it does not exist, user either logged out or never logged in
    let accessToken = localStorage.getItem("access_token");
    let idToken = localStorage.getItem("id_token");
    let expiresAt = JSON.parse(localStorage.getItem("expires_at"));

    let currentMillis = new Date().getTime();
    //If we are within 5 minutes of expiring, renew the session if this function gets called, indicating the user is still busy.
    let timeLeft = (expiresAt - currentMillis)

    if (timeLeft < this.fiveMinutes && accessToken && idToken) {
      this.auth0.checkSession({}, this.authenticationSession)
    }
    return currentMillis < expiresAt && accessToken && idToken;
  };


  getUserPermissions = () => {
    let idToken = localStorage.getItem("id_token");

    let permissionsRole = this.permissions.ROLE_UNAUTHORIZED
    if (idToken) {
      let decodedToken = jwtDecode(idToken);
      console.log(decodedToken)
      let roles = decodedToken["https://dtn.com/roles"];

      const permissionsArr = Object.keys(this.permissions).map(k => {
        return roles.includes(`dtn-usermanager:${k}`) ? this.permissions[k] : this.permissions.ROLE_UNAUTHORIZED
      });

      const maxlvlPermission = Math.max(...Array.from(permissionsArr, p => p.lvl));
      permissionsRole = permissionsArr.find(p => p.lvl === maxlvlPermission);
    }

    return permissionsRole;
  };

  user;
  getUser = () => {
    if (!this.user) {
      let idToken = localStorage.getItem("id_token");
      let decodedToken = jwtDecode(idToken);
      console.log(decodedToken)
      let roles = decodedToken["https://dtn.com/roles"];
      this.user = {
        roles: roles.map(r => r.split(":")[1])
      }
    }
    return this.user;
  }

  hasPermission = (lvl) => {
    return this.getUserPermissions().lvl >= lvl.value;
  }
}



// WEBPACK FOOTER //
// ./src/authentication/Authentication.js